import { TaskType } from "../../../../../types";
import theme from "../../../theme";

const shortenedTypeTag = {
  FORK_JOIN_COLLAPSED: "DYN. CHILDREN",
  [TaskType.JSON_JQ_TRANSFORM]: "JSON JQ",
  [TaskType.EXCLUSIVE_JOIN]: "EX. JOIN",
  [TaskType.FORK_JOIN]: "FORK JOIN",
  [TaskType.FORK_JOIN_DYNAMIC]: "DYN. FORK",
  [TaskType.INLINE]: "INLINE",
  [TaskType.KAFKA_PUBLISH]: "KAFKA",
  [TaskType.SIMPLE]: "SIMPLE",
} as const;

type TaskTypeKeys = keyof typeof shortenedTypeTag;

const CardLabel = ({ type }: { type: TaskTypeKeys }) => (
  <div
    style={{
      position: "absolute",
      top: "20px",
      right: "20px",
      height: "fit-content",
      padding: "4px 8px",
      fontSize: "0.8em",
      background: theme.taskCard.cardLabel.background,
      color: theme.taskCard.cardLabel.color,
      borderRadius: "5px",
      marginLeft: "8px",
    }}
  >
    {shortenedTypeTag[type as TaskTypeKeys] || type}
  </div>
);
export default CardLabel;
